import { DataList, Flex, Heading, Link, Separator, Text } from '@radix-ui/themes';
import { lowerCaseToTitleCase, capitalizeFirst } from '../util/string';

interface Student {
  [key: string]: string | number | undefined;
  student_id?: number;
  student_name?: string;
  student_code?: string;
  age?: number;
  gender?: string;
  nationality?: string;
  personality?: string;
  flexibility?: string;
  academic_year?: number;
  academic_ability?: number;
  economic_status?: string;
  family_support?: string;
  social_environment?: string;
}

export function StudentDetails({
  sessionId,
  student
}: {
  sessionId?: string;
  student?: Student;
}) {
  const displayFields = ['age', 'gender', 'nationality', 'personality', 'flexibility', 'social_environment', 'family_support', 'economic_status', 'academic_ability'];

  const selectAndCopy = (event: React.MouseEvent<HTMLSpanElement>) => {
    const selection = window.getSelection();
    const range = document.createRange();
    if (event.currentTarget && selection) {
      range.selectNodeContents(event.currentTarget);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  return (<>
    <Heading size="3" mb="4" as="h2">
      Student Information
    </Heading>
    <DataList.Root orientation="vertical">
      {sessionId && (
        <DataList.Item>
          <DataList.Label>Session ID:</DataList.Label>
          <DataList.Value>
            <Text size="1" onClick={selectAndCopy}>{sessionId}</Text>
          </DataList.Value>
        </DataList.Item>
      )}
      <DataList.Item>
        <DataList.Label>Student Name</DataList.Label>
        <DataList.Value>{student?.student_name}</DataList.Value>
      </DataList.Item>
      {student && Object.keys(student).filter(key => (
        displayFields.includes(key)
      )).map(key => (
        <DataList.Item key={key}>
          <DataList.Label>{lowerCaseToTitleCase(key)}</DataList.Label>
          <DataList.Value>{capitalizeFirst(student[key]+'')}</DataList.Value>
        </DataList.Item>
      ))}
    </DataList.Root>
    <Separator my="3" size="4" />
    <Flex direction="column" gap="2">
      <Link
        target="_blank" 
        underline="hover" 
        weight="bold" 
        href="https://forms.microsoft.com/Pages/ResponsePage.aspx?id=9mf-EVT9gUmSX5TDbtewhtD29nPVZ9dNtGHz67rW745URFoyOUNFSVBPUVo4UUtCMFlQNlJPN0ZOSy4u"
      >
        <Text as="p">Session Survey &raquo;</Text>
      </Link>
      <Link
        target="_blank" 
        underline="hover" 
        weight="bold" 
        href="https://forms.microsoft.com/Pages/ResponsePage.aspx?id=9mf-EVT9gUmSX5TDbtewhtD29nPVZ9dNtGHz67rW745UQ0o2U05OSEpJTFVOWVExVURNWEhQS1E5SS4u"
      >
        <Text as="p">General Survey &raquo;</Text>
      </Link>
    </Flex>
  </>)
}
